import Carousel from "./Carousel/index";
import { useSlide, useSlideLabel } from "./SlideContext/index";
export { Carousel, useSlide, useSlideLabel };
export default Carousel;
